import { mapDesactivatedAutomation } from '90.quickConnect.Models/mappings';
import { FieldDesc } from '90.quickConnect.Models/models';

// DesactivatedAutomation pour les Wkf
export const desactivatedAutomationWkf = (declaration: FieldDesc[], currentStepId: string) => {
  declaration.forEach((field: FieldDesc) => {
    const nextDisableAutomationValue = field.id.localeCompare(currentStepId, undefined, { sensitivity: 'base' }) === 0;
    field.items = mapDesactivatedAutomation(field.items, !nextDisableAutomationValue);
    field.desactivatedAutomation = !nextDisableAutomationValue;
  });
};
